import React from 'react';

import ServiceMatrixContainer from '@totem/components/portfolio/serviceMatrix/ServiceMatrixContainer';
import ServiceMatrixFilters from '@totem/components/portfolio/serviceMatrix/ServiceMatrixFilters';
import ServiceMatrixTable from '@totem/components/portfolio/serviceMatrix/ServiceMatrixTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const ServiceMatrixPage = () => (
  <ContentLayout>
    <ServiceMatrixContainer>
      <IBCard isCovered title="Service Matrix">
        <ServiceMatrixFilters />
        <ServiceMatrixTable />
      </IBCard>
    </ServiceMatrixContainer>
  </ContentLayout>
);

export default ServiceMatrixPage;
